import React from 'react';

import CreateEvent from '../components/CreateEvent/CreateEvent';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';

const CreateEventPage = () => {
  return (
    <div className="create-event-page">
      <Header />
      <CreateEvent />
      <Footer />
    </div>
  );
};

export default CreateEventPage;
